var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-circle",staticStyle:{"width":"16px","height":"16px","border-radius":"50%"},style:({ 'background-color': _vm.color})})
}
var staticRenderFns = []

export { render, staticRenderFns }